// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3cuKr44tezHUjlYtEWBr8J"};


/*****************
 ** WEBPACK FOOTER
 ** ./form/thank-you/styles.scss
 ** module id = 437
 ** module chunks = 0
 **/